import { useContext, useEffect } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_Form({
    id,
    onSubmit,
    Composition,
    className,
    style,
    children,
    Compress }) {
    const UI = useContext(Context_UI);
    return (
        <form
            className={`Input_Form ${className}`}
            style={style}
            onSubmit={onSubmit}
            id={id}
            Composition={Composition}
            Compress={Compress ? "Compress" : undefined}>
            {children}
        </form>
    )
}

